import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import {
  FaTachometerAlt,
  FaKey,
  FaWallet,
  FaSignOutAlt,
  FaIdCard
} from "react-icons/fa";
import "./DashboardLayout.css";

const DashboardLayout = () => {
  const [dateTime, setDateTime] = useState("");
  const [wallet, setWallet] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));

  /* 🔐 Auth check + time */
  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    const updateTime = () => {
      const now = new Date();
      setDateTime(
        now.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }) +
          " | " +
          now.toLocaleTimeString("en-IN")
      );
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, [user, navigate]);

  /* 🔥 WALLET LIVE SYNC */
  useEffect(() => {
    if (!user?.api_key) return;

    const fetchWallet = async () => {
      try {
        const res = await fetch("/api/get_user.php", {
          headers: {
            "x-api-key": user.api_key
          }
        });

        const data = await res.json();

        if (data.status) {
          const updatedUser = {
            ...user,
            wallet_balance: data.user.wallet_balance
          };

          localStorage.setItem("user", JSON.stringify(updatedUser));
          setWallet(data.user.wallet_balance);
        }
      } catch (e) {
        console.error("Wallet sync failed", e);
      }
    };

    fetchWallet();

    // 🔥 listen after RC / any service deduct
    const syncWallet = () => fetchWallet();
    window.addEventListener("walletUpdated", syncWallet);

    return () => window.removeEventListener("walletUpdated", syncWallet);
  }, []);

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/login");
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className="dashboard-wrapper">
      <aside className="sidebar">
        <h2 className="logo">VahanAPI</h2>

        <ul className="menu">
          <li
            className={isActive("/dashboard") ? "active" : ""}
            onClick={() => navigate("/dashboard")}
          >
            <FaTachometerAlt className="menu-icon" />
            <span>Dashboard</span>
          </li>

          <li
            className={isActive("/dashboard/rc-normal") ? "active" : ""}
            onClick={() => navigate("/dashboard/rc-normal")}
          >
            <FaIdCard className="menu-icon" />
            <span>RC Normal Search</span>
          </li>
           <li
            className={isActive("/dashboard/rcfull") ? "active" : ""}
            onClick={() => navigate("/dashboard/rcfull")}
          >
            <FaIdCard className="menu-icon" />
            <span>RC get</span>
          </li>

          <li
            className={isActive("/dashboard/api-key") ? "active" : ""}
            onClick={() => navigate("/dashboard/api-key")}
          >
            <FaKey className="menu-icon" />
            <span>API Key</span>
          </li>

          <li
            className={isActive("/dashboard/wallet") ? "active" : ""}
            onClick={() => navigate("/dashboard/wallet")}
          >
            <FaWallet className="menu-icon" />
            <span>Wallet</span>
          </li>

          <li onClick={logout}>
            <FaSignOutAlt className="menu-icon" />
            <span>Logout</span>
          </li>
        </ul>
      </aside>

      <div className="main-area">
        <header className="header">
          <span>{dateTime}</span>
          <span className="header-right">Wallet: ₹{wallet}</span>
        </header>

        {/* 🔥 ROUTED CONTENT */}
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
